import "../Css/BlogPage.css";
import SectionComp from "../Component/SectionComp";
import { NavLink } from "react-router-dom";
import weddingBlogs from "../Component/weddingBlogs";
import moment from "moment";

const BlogPage = () => {
  return (
    <>
      <section className="blog-section-1">
        <div className="container">
          <div className="blog-section-1-main-con">
            <SectionComp
              title={"BLOGS"}
              para={
                "Real stories, real smiles — captured from events we were proud to be part of."
              }
            />
            <div className="blog-section-1-details-main-con">
              <div className="row">
                {weddingBlogs?.map((elem, index) => {
                  return (
                    <div className="col-md-4" key={index}>
                      {/* Added key prop */}
                      <div className="home-blog-card-main-con">
                        <div
                          className="home-blog-card-image-main-con"
                          style={{
                            backgroundImage: `url(${
                              elem.blogImage ??
                              "https://find-company-online.co.uk/uploads/images/no-thumb.png"
                            })`,
                          }}
                        >
                          <img src="https://find-company-online.co.uk/uploads/images/no-thumb.png" />
                          {/* Display the image */}
                          <div className="home-blog-card-image-overlay-date">
                            <span>
                              {moment(new Date()).format("DD MMM YY")}
                            </span>
                          </div>
                        </div>
                        <div className="home-blog-card-image-details-main-con">
                          <h4>{elem.title}</h4>
                          {/* Access the blogtitle property */}
                          <h5>{elem.short_description}</h5>
                          <NavLink
                            to={"/view/" + elem.slug}
                            className="home-blog-card-details-btn"
                          >
                            <button className="btn">Read More</button>
                          </NavLink>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BlogPage;
